import { DEFAULT_COUNTRY_CODE } from "./constants";

export const formatPhoneNumber = (countryCode: string, phoneNumber: string): string => {
  if (countryCode !== DEFAULT_COUNTRY_CODE) return phoneNumber;
  // Remove any non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, "");

  // Split the string into pairs of digits
  const pairs = cleaned.match(/.{1,2}/g) || [];

  // Join the pairs with spaces
  const formatted = pairs.join(" ");

  return formatted;
};

export const cleanupPhoneNumber = (phoneNumber: string): string => {
  return phoneNumber.replace(/\D/g, "");
};
